"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const type_graphql_1 = require("type-graphql");
const typeorm_1 = require("typeorm");
const OsmosysBaseEntity_1 = require("../OsmosysBaseEntity");
const User_1 = require("./User");
let UserInvite = class UserInvite extends OsmosysBaseEntity_1.OsmosysBaseEntity {
};
tslib_1.__decorate([
    type_graphql_1.Field(() => User_1.User),
    typeorm_1.ManyToOne(() => User_1.User, {
        cascade: true,
        nullable: true,
        onDelete: 'SET NULL',
    }),
    tslib_1.__metadata("design:type", Object)
], UserInvite.prototype, "creatingUser", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => Date, { nullable: true }),
    typeorm_1.Column({ nullable: true, type: 'timestamp' }),
    tslib_1.__metadata("design:type", Date)
], UserInvite.prototype, "usedToSignupAt", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(),
    typeorm_1.Column(),
    tslib_1.__metadata("design:type", String)
], UserInvite.prototype, "inviteCode", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => String, { nullable: true }),
    typeorm_1.Column({ nullable: true }),
    tslib_1.__metadata("design:type", String)
], UserInvite.prototype, "error", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => User_1.User),
    typeorm_1.ManyToOne(() => User_1.User, user => user.invites, {
        nullable: true,
        onDelete: 'SET NULL',
    }),
    typeorm_1.JoinColumn({ name: 'user_id' }),
    tslib_1.__metadata("design:type", Object)
], UserInvite.prototype, "user", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(),
    typeorm_1.RelationId((obj) => obj.user),
    tslib_1.__metadata("design:type", Number)
], UserInvite.prototype, "userId", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => User_1.User, { nullable: true }),
    typeorm_1.OneToOne(() => User_1.User, user => user.acceptedInvite, {
        nullable: true,
        onDelete: 'SET NULL',
    }),
    tslib_1.__metadata("design:type", Object)
], UserInvite.prototype, "acceptingUser", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => String, { nullable: true }),
    typeorm_1.Column({ nullable: true, type: 'character varying' }),
    tslib_1.__metadata("design:type", Object)
], UserInvite.prototype, "emailHtml", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => [String], { nullable: true }),
    typeorm_1.Column({
        array: true,
        nullable: true,
        type: 'timestamp',
    }),
    tslib_1.__metadata("design:type", Array)
], UserInvite.prototype, "validationCheckTimes", void 0);
UserInvite = tslib_1.__decorate([
    type_graphql_1.ObjectType(),
    typeorm_1.Entity()
], UserInvite);
exports.UserInvite = UserInvite;
class UserInviteEntity extends UserInvite {
    toString() {
        return `User invite #${this.id}`;
    }
}
exports.UserInviteEntity = UserInviteEntity;
//# sourceMappingURL=UserInvite.js.map